<div class="row">
  <div class="col-12">
    <h3>Locations</h3>
  </div>
  <div class="col-12">
    <div class="row m-1">
      <app-admin-nav></app-admin-nav>
      @if (permissions.userType == 'A' || permissions.userType == 'B') {
        <button routerLink="/administration/location/edit/0" class="btn btn-primary py-0 mr-1"><i class="fa fa-plus"></i>Add Location</button>
      }
      <input type="text" name="search" value="" class="col-12 col-sm-6 col-md-3 form-control" placeholder="keyword" (keyup)="filter('name,user_name,user_type_desc,company',$event.target.value, false)">
    </div>
  </div>
  <div class="col-12">
    <table class="table table-striped tableList">
      <thead class="table-dark">
        <tr>
          <th (click)="sort('group_name')">
            <a [className]="(sortField | async) == 'group_name'? (sortDirection | async) : 'sort'">Company</a>
          </th>
          <th (click)="sort('name')">
            <a [className]="(sortField | async) == 'name'? (sortDirection | async) : 'sort'">Location Name</a>
          </th>
          <th>
            City
          </th>
          <th>
            State
          </th>
          <th>
            Status
          </th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        @for (location of rowItems; track location) {
          <tr >
            <td>{{ location.group_name }}</td>
            <td>{{ location.name }}</td>
            <td>{{ location.city }}</td>
            <td>{{ location.state }}</td>
            <td>{{ getStatusCode( location.status_cde ) }}</td>
            <td nowrap>
              <div class="btn-group" role="group" aria-label="buttons">
                <button class="btn btn-info p-1" routerLink="/administration/location/edit/{{location.location_id}}"><i class="fa fa-pencil" ></i>Edit</button>
                <!-- <button class="disabled btn btn-danger p-1"><i class="fa fa-trash" alt="Delete" ></i></button>(click)="delete(location.location_id)" -->
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="row">
      <div class="col-12">
        <app-pager [allItems]="locations | async" (pagedItemsNew)="setPagedItem($event)"></app-pager>
      </div>
    </div>
  </div>
</div>
